import {
  EMPTY_REQUEST_CONTEXT_PAYLOAD,
  type RequestContextPayload
} from './types';

function asString(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

/** Keeps only the contract keys; unknown JSON fields are dropped. */
export function pickRequestContextPayload(
  input: unknown
): RequestContextPayload {
  if (!input || typeof input !== 'object') {
    return { ...EMPTY_REQUEST_CONTEXT_PAYLOAD };
  }

  const source = input as Record<string, unknown>;

  return {
    http_user_agent: asString(source.http_user_agent),
    sec_ch_ua: asString(source.sec_ch_ua),
    sec_ch_ua_mobile: asString(source.sec_ch_ua_mobile),
    sec_ch_ua_platform: asString(source.sec_ch_ua_platform),
    cdn_bot_score: asString(source.cdn_bot_score),
    cdn_custom_bots: asString(source.cdn_custom_bots),
    cdn_ai_bots: asString(source.cdn_ai_bots),
    cdn_public_bots: asString(source.cdn_public_bots),
    cdn_bot_tags: asString(source.cdn_bot_tags)
  };
}
